import classnames from 'classnames';
import './Alert.scss';
import { Grid } from '../../shared/grid';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';interface AlertProps {
  children: React.ReactNode;
  className?: string;
  type?:string;
  icon?:string;
  onClose?: () => void;
  keyDown?: any;
}

export const Alert = (props: AlertProps): React.ReactElement =>{
  const { children, className, onClose, type, icon, keyDown } = props;
  const classes = classnames(
    'use-site-alert usa-site-alert--emergency usa-site-alert--no-heading',
    className
  );
  return(
    <Grid desktop={{col:12}}>
    <section
        className={classes}
        aria-label="Site alert"
        data-testid="siteAlert"
      >
        <div className={`usa-alert---${type}`}>
          <Grid desktop={{col:1}}>
            <i className={`fas ${icon} alertIcon`}/>

          </Grid>
          <Grid desktop={{col: 10}}>
            <p dangerouslySetInnerHTML={{__html: children as String}} />

          </Grid>
          <Grid desktop={{col: 1}}>
            {
              type !=='warning' && 
            <CloseRoundedIcon style={{cursor: 'pointer', fontSize: 'xx-large' }} 
              onClick={onClose} 
              tabIndex={0}
              onKeyDown={keyDown}
            />
            }
          </Grid>
        </div>
      </section>
    </Grid>
  )
}